import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {initBlock, resetBlock, resetData, reportDWH} from './AddonsAndUpgradesBlockSlice';
import {getUserUpgradesAsync} from './AddonsAndUpgradesBlockAsyncThunk';
import Skeleton from 'react-loading-skeleton';
import {navigateTo} from '../../../utilities/StringHelpers/StringHelpers';
import UserUpgradeList from './Partials/UserUpgradeList';
import UserAddonList from './Partials/UserAddonList';
import {internalPage} from '../../../Components/Page/SelfCarePage/Constant';
import {goToPage, setSelectedService, setRetainSubscriberOnLoad} from '../../../Components/Page/SelfCarePage/SelfCareSlice';
import PopUpWithAnimation from '../../Shared/PopUpWithAnimation/PopUpWithAnimation';
import OtpExtendedPopup from '../../Block/SelfcareExtendedOtpButtonBlock/PopUp/OtpExtendedPopup';

const AddonsAndUpgradesBlock = (props) => {
  const [currentTab, setCurrentTab] = useState('userUpgrades'); //userUpgrades|userAddons
  const [isShowMoreOpen, setIsShowMoreOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [isDisplayOtpPopup, setIsDisplayOtpPopup] = useState(false);
  const [otpExtendedFinished, setOtpExtendedFinished] = useState(false);

  useEffect(() => {
    props.initBlock({currentBlock: props.iContent});
  }, []);

  useEffect(() => {
    if (props.selectedSubscriber) {
      props.resetData();
      props.getUserUpgradesAsync();
    }
  }, [props.selectedSubscriber?.productSubscriberNo]);

  useEffect(() => {
    if (otpExtendedFinished) {
      props.setSelectedService(selectedItem);
      navigateTo(selectedItem.selfCareCmsData?.linkToInstall);
    }
  }, [otpExtendedFinished]);

  let currentView = null;
  if (currentTab == 'userUpgrades') {
    currentView = (
      <UserUpgradeList
        serviceList={getFilterResults(props.userUpgrades)}
        onServiceClick={handleOnUpgradeClick}
        maxServicesToDisplay={props.maxServicesToDisplay}
        isShowMoreOpen={isShowMoreOpen}
      />
    );
  } else {
    currentView = (
      <UserAddonList
        serviceList={getFilterResults(props.userAddons)}
        onServiceClick={handleOnServiceClick}
        maxServicesToDisplay={props.maxServicesToDisplay}
        isShowMoreOpen={isShowMoreOpen}
        isFullAuthenticated={props.isFullAuthenticated}        context={props.context}      />
    );
  }

  return (
    <>
      {props.isFinishLoading ? (
        <div className='addons-and-upgrades-wrapper'>
          <div className='title'> {props.title} </div>

          <div className='addons-and-upgrades'>
            <div className='tabs-wrapper'>
              <span onClick={() => handleOnSelectTab('userUpgrades')} className={currentTab == 'userUpgrades' ? 'active' : ''}>
                {props.userUpgradesTabTitle}
              </span>
              <span onClick={() => handleOnSelectTab('userAddons')} className={currentTab == 'userAddons' ? 'active' : ''}>
                {props.userAddonsTabTitle}
              </span>
            </div>

            <div className='content-wrapper'>{currentView}</div>
          </div>

          {displayShowMoreButton() && (
            <div className='show-more-wrapper'>
              <span onClick={() => handleShowMoreClick()} className={isShowMoreOpen ? 'open' : ''}>
                {isShowMoreOpen ? 'הצג פחות' : 'הצג עוד'}
              </span>
            </div>
          )}
        </div>
      ) : (
        <div className='skeleton-wrapper'>
          <Skeleton containerClassName='main-title' />
          <Skeleton containerClassName='main-content' />
          <Skeleton containerClassName='show-more' />
        </div>
      )}

      <PopUpWithAnimation className='selfcareExtendedOtpPopUp' isShow={isDisplayOtpPopup} onClose={() => setIsDisplayOtpPopup(false)}>
        <OtpExtendedPopup
          setShowPopUp={setIsDisplayOtpPopup}
          showPopup={isDisplayOtpPopup}
          setOtpExtendedFinished={setOtpExtendedFinished}
        />
      </PopUpWithAnimation>
    </>
  );

  function displayShowMoreButton() {
    if (!props.maxServicesToDisplay) {
      return false;
    }

    if (currentTab == 'userUpgrades') {
      if (props.userUpgrades.length == 0) {
        return false;
      }
      if (props.userUpgrades.length > props.maxServicesToDisplay) {
        return true;
      } else {
        return false;
      }
    }

    if (currentTab == 'userAddons') {
      if (props.userAddons.length == 0) {
        return false;
      }
      if (props.userAddons.length > props.maxServicesToDisplay) {
        return true;
      } else {
        return false;
      }
    }

    return false;
  }

  function getFilterResults(arr) {
    if (!props.maxServicesToDisplay) {
      return arr;
    }

    if (isShowMoreOpen) {
      return arr;
    } else {
      return arr.slice(0, props.maxServicesToDisplay);
    }
  }

  function handleOnSelectTab(tab) {
    setCurrentTab(tab);
  }

  function handleOnUpgradeClick(e, item) {
    e.preventDefault();
    if (
      props.loginData.isFullAuthenticated ||
      props.loginData.isOtpExtendedAuthenticated ||
      props.worldType == 'cellular' ||
      props.worldType == 'abroad'
    ) {
      props.setSelectedService(item);
      var storage = window.localStorage || window.sessionStorage;
      storage.setItem('returnUrl', document.location.href);
      navigateTo(item.selfCareCmsData?.linkToInstall);
    } else {
      setSelectedItem(item);
      props.setRetainSubscriberOnLoad(true);
      setIsDisplayOtpPopup(true);
    }
  }

  function handleOnServiceClick(e, item) {
    e.preventDefault();
    props.setSelectedService(item);

    props.reportDWH({actionType: 'Service Page', status: 'Ongoing', messageText: 'Service Page Displayed'});

    if (item.selfCareCmsData?.worldType?.toUpperCase() === 'TV') {
      navigateTo(item.selfCareCmsData?.linkToInstall);
    } else {
      props.goToPage(internalPage.ServiceDetailsPage);
    }
  }

  function handleShowMoreClick() {
    setIsShowMoreOpen(!isShowMoreOpen);
  }
};

const mapStateToProps = (state) => {
  return {
    worldType: state.addonsAndUpgradesBlock.worldType,
    title: state.addonsAndUpgradesBlock.title,
    userUpgradesTabTitle: state.addonsAndUpgradesBlock.userUpgradesTabTitle,
    userAddonsTabTitle: state.addonsAndUpgradesBlock.userAddonsTabTitle,
    isFinishLoading: state.addonsAndUpgradesBlock.isFinishLoading,
    userUpgrades: state.addonsAndUpgradesBlock.userUpgrades,
    userAddons: state.addonsAndUpgradesBlock.userAddons,
    maxServicesToDisplay: state.addonsAndUpgradesBlock.maxServicesToDisplay,
    selectedSubscriber: state.selfcarePage.selectedSubscriber,
    isFullAuthenticated: state.authentication.loginData.isFullAuthenticated,
    loginData: state.authentication.loginData,
    retainSubscriberOnLoad: state.selfcarePage.retainSubscriberOnLoad,
  };
};

const mapDispatchToProps = {
  initBlock,
  resetBlock,
  resetData,
  reportDWH,
  getUserUpgradesAsync,
  goToPage,
  setSelectedService,
  setRetainSubscriberOnLoad,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddonsAndUpgradesBlock);
